import { createSelector } from '@reduxjs/toolkit';
import modalsSelector from './modals';

const updatePixelConfModalSelector = createSelector(modalsSelector, (modals) => modals.updatePixelConf);

export default updatePixelConfModalSelector;
